module.exports = __webpack_public_path__ + "img/comp_img.08defa4e.png";